import React, {useEffect, useRef, useState} from 'react';
import {LayoutContainer} from "../../../modules/Layout";
import {useDispatch, useSelector} from "react-redux";
import './CopilotPage.scss';
import WelcomeModal from "../../../modules/WelcomeModal/WelcomeModal";
import {KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL} from "../../../modules/Tour/helpers";
import ChatsList from "../../../shared/chat/components/ChatsList/ChatsList";
import MessageBlock from "../../../shared/chat/components/MessageBlock/MessageBlock";
import {getHeaderHeight, isCheckAuth} from "../../../utils/helperFunctions";
import {useLocation} from "react-router-dom";
import {TABS} from "../../../shared/chat/components/AiChats/AiChats";
import SearchBlock from "../../../shared/chat/components/SearchBlock/SearchBlock";
import {ROUTERS_MAP} from "../../../utils/routes";
import UserInfoModal from "../../Dashboard/containers/Users/modals/userInfoModal/UserInfoModal";
import {history} from "../../../utils/history";
import {useTranslation} from "react-i18next";
import {io} from "socket.io-client";
import {HOST_NAME} from "../../../redux/api";
import {
    GetChatSessionsService,
    UpdateChatSessionService,
    UpdateSelectedIdSessionService
} from "../../../redux/actions/chatActions";

const CopilotPage = (props) => {
    const location = useLocation();
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);
    const videoActiveTab = useSelector(state => state.videos?.videoActiveTab);
    const isAiAgents = (location.pathname || '').includes('/copilot');
    const [isOpenSidePanel, setIsOpenSidePanel] = useState(isAiAgents);
    const [activeTab, setActiveTab] = useState(TABS.MESSAGE);
    const userProfile = useSelector(state => state.profile.userProfile);
    const [currentUser, setCurrentUser] = useState(null);
    const [showPersonsModal, setShowPersonsModal] = useState(false)
    const isAuth = isCheckAuth();
    const dispatch = useDispatch();
    const selectedIdSession = useSelector(state => state.chat.selectedIdSession);
    const token = localStorage.getItem('jwtToken');
    const selectedIdSessionRef = useRef(null);

    useEffect(() => {
        selectedIdSessionRef.current = selectedIdSession; // Обновляем ref при каждом изменении состояния
    }, [selectedIdSession]);

    useEffect(() => {
        setHeaderHeight(getHeaderHeight() + 45)
    }, [videoActiveTab])

    useEffect(() => {
        const visibleWelcomeModal = localStorage.getItem(KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL);
        if (!visibleWelcomeModal) {
            setShowWelcomeModal(true);
        }
    }, []);

    function openUserModal(data) {
        if (userProfile?.attached_person?.id === data.id) {
            history.push(ROUTERS_MAP.PROFILE);
        } else {
            setShowPersonsModal(true)
            setCurrentUser(data)
        }
    }

    function closeModal() {
        setShowPersonsModal(false)
    }

    const updateSessions = async (data) => {
        const id = (location.pathname || '').split('/')?.at(-1);
        try {

            if (data?.update_type === 'delete') {
                const response = await dispatch(GetChatSessionsService({}));
                if (data?.object_id === selectedIdSessionRef?.current) {
                    dispatch(UpdateSelectedIdSessionService(response?.[0]?.id));
                    if (!response?.[0]?.is_read) UpdateChatSessionService(response?.[0]?.id, {is_read: true});
                }
            }
            if (data?.update_type === 'create') {
                dispatch(GetChatSessionsService({}));
            }
            if (data?.update_type === 'update') {
                dispatch(GetChatSessionsService({}));
            }

        } catch (e) {
            console.error(e)
        }
    }


    useEffect(() => {
        const socketFavorites = io(`${HOST_NAME}/document_updates`)

        if (isAuth) {

            socketFavorites.on('connect', function () {
                console.log('Подключено к серверу user');
                socketFavorites.emit('join_room', {
                    token: token,
                    room: `user_${userProfile?.id}`
                }, function (response) {
                    if (response && response.error) {
                        console.error('Ошибка при присоединении к комнате:', response.error);
                    } else {
                        console.log(`Присоединились к комнате user_${userProfile?.attached_person?.id}`);
                    }
                });
            });

            // Обрабатываем ошибку подключения
            socketFavorites.on('connect_error', function (error) {
                console.error('Не удалось подключиться:', error);
            });

            // Обрабатываем отключение от сервера
            socketFavorites.on('disconnect', function (reason) {
                console.log('Отключено от сервера:', reason);
            });

            // Слушаем события 'update' и выводим их в консоль
            socketFavorites.on('update', async function (data) {
                if (data?.object_type === 'chat_session') {
                    updateSessions(data)
                }

                console.log('Copilot page. Получено обновление:', data);
            });
        }
        return () => {
            socketFavorites.disconnect();
        }
    }, [isAuth, userProfile]);

    const getSessions = async () => {
        try{
            const response = await dispatch(GetChatSessionsService({}));
            dispatch(UpdateSelectedIdSessionService(response?.[0]?.id));
            if (!response?.[0]?.is_read) UpdateChatSessionService(response?.[0]?.id, {is_read: true});
        }catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        if (isAuth) {
            getSessions()
        }
    }, []);

    React.useEffect(() => {
        const element = document.querySelector('.ant-layout-header');
        if (!element) return;

        const resizeObserver = new ResizeObserver((entries) => {
            setHeaderHeight(getHeaderHeight() + 45)
        });

        resizeObserver.observe(element);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <LayoutContainer isSearch className="channels-layout-container" title={'Copilot'}>
            <div className='copilot'>
                {activeTab === TABS.MESSAGE ?
                    <div className='copilot__left'
                         style={{width: isOpenSidePanel ? '22%' : '0', minWidth: isOpenSidePanel ? 300 : 0}}>
                        <ChatsList/>
                    </div>
                    : null
                }
                <div className='copilot__right'>
                    <div className='copilot__right-chat chat'>
                        {activeTab === TABS.MESSAGE ?
                            <MessageBlock
                                activeTab={activeTab}
                                isOpenPopover={false}
                                isOpenSidePanel={false}
                                setActiveTab={setActiveTab}
                                onClickBurger={() => setIsOpenSidePanel(!isOpenSidePanel)}
                                containerHeight={headerHeight}
                            />
                            : null}
                        {activeTab === TABS.SEARCH ?
                            <SearchBlock
                                activeTab={activeTab}
                                openUserModal={openUserModal}
                                setActiveTab={setActiveTab}
                                containerHeight={headerHeight}
                            />
                            : null}
                    </div>
                </div>
            </div>
            <WelcomeModal open={showWelcomeModal} onClose={() => setShowWelcomeModal(false)}/>
            {showPersonsModal && <UserInfoModal show={showPersonsModal} closeModal={closeModal} user={currentUser}/>}
        </LayoutContainer>
    );
};

export default CopilotPage;